function slider() {
	$('.slider-js-1').slider({
		range: true,
		min: 0,
		max: 70,
		step: 1,
		values: [0, 100],

		slide: function(event, ui) {
			$('.slider-value-1-js').html(ui.values[0]);
			$('.slider-value-2-js').html(ui.values[1]);

			const $sliderpos = $(this)
				.find('.ui-slider-handle:first')
				.css('left');
			const $sliderpos2 = $(this)
				.find('.ui-slider-handle:eq(1)')
				.css('left');

			$('.slider-value-1-js').css({ left: $sliderpos });
			$('.slider-value-2-js').css({ left: $sliderpos2 });
		},
		stop: function() {
			const $sliderpos = $(this)
				.find('.ui-slider-handle:first')
				.css('left');
			const $sliderpos2 = $(this)
				.find('.ui-slider-handle:eq(1)')
				.css('left');

			$('.slider-value-1-js').css({ left: $sliderpos });
			$('.slider-value-2-js').css({ left: $sliderpos2 });
		}
	});

	// var val = $( ".slider-js" ).slider('option','values');

	// document.getElementById("js_get_value").addEventListener('click', function(){

	//     console.log( val );

	// });
}
slider();
